import {
  ClearButtonBehaviour,
  GroupBox,
  Labeled,
  NumericInput,
} from '@infotech-soe/erp-ui-kit';
import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import { messages } from './messages';
import PresenceValueCheckboxes from './PresenceValueCheckboxes';
import { InputConditionsProps, InputName } from './types';

const NumberConditions = ({
  column: { domain },
  condition: { value },
  onChange,
}: InputConditionsProps<number | boolean>): React.JSX.Element => {
  const { formatMessage } = useIntl();

  return (
    <GroupBox label={formatMessage(messages.condition)}>
      <GroupBox.Content className="row m-mt-md">
        <PresenceValueCheckboxes value={value} onChange={onChange} />
        <div className="row col-12">
          <Labeled className="col-6" label={formatMessage(messages.greater)}>
            <NumericInput
              disabled={value.empty || value.notEmpty}
              name={InputName.BEFORE}
              precision={domain.precision}
              value={value.before}
              onChange={(v: number | null) => onChange(v, InputName.BEFORE)}
              withClearButton={ClearButtonBehaviour.ALWAYS}
            />
          </Labeled>
          <Labeled className="col-6" label={formatMessage(messages.less)}>
            <NumericInput
              disabled={value.empty || value.notEmpty}
              name={InputName.AFTER}
              precision={domain.precision}
              value={value.after}
              onChange={(v: number | null) => onChange(v, InputName.AFTER)}
              withClearButton={ClearButtonBehaviour.ALWAYS}
            />
          </Labeled>
        </div>
      </GroupBox.Content>
    </GroupBox>
  );
};

export default memo(NumberConditions);
